export const OpenInNewTabIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title> open-in-new-tab </title>
    <g fillRule="evenodd">
      <path d="M15.001 7l-6 .005V8H13.3l-7 7.258.75.742L14 8.75V13l1 .016V7z"></path>
    </g>
  </svg>
);
